import axios from "axios";

const API_KEY = process.env.REACT_APP_MAP_IR_KEY;
const API_NAME = process.env.REACT_APP_API_NAME;
const fetchOstan = async (postalCode) => {
  const URL = `https://map.ir/geo-data/postalcodes/${postalCode}/tour-province`;
  try {/*  */
    const response = await axios.get(`${URL}`, {
      params: {
        [API_NAME]: API_KEY
      }
    })
    return {
      data: response.data.data,
      err: ""
    };

  } catch (err) {
    return {
      data: null,
      err: "این کد پستی پیدا نشد دلبندم💛❤❤❤💘"
    }
  }

}

export default fetchOstan;